export const BOON_SAP_ENTITLEMENT = 'Platform.SapEnabled';
